class ScrollToTop extends HTMLElement{
    connectedCallback(){
        this.stickyAddToCart = document.querySelector('sticky-add-to-cart.sticky-add-to-cart');

        // Scroll back to top when clicked
        this.addEventListener("click", () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });

        // Check for button postion on load
        this.showButton();

        // Element shows up when scrolling
        document.addEventListener("scroll", () => {
            this.showButton();
        });

        this.syncStickyAddToCartPosition();
        if(this.stickyAddToCart){
            this.stickyAddToCartObserver = new MutationObserver(() => {
                this.syncStickyAddToCartPosition();
            });
            this.stickyAddToCartObserver.observe(this.stickyAddToCart, {
                attributes: true,
                attributeFilter: ["class"]
            });
        }
    }

    showButton(){
        if(document.body.scrollTop > 20 || document.documentElement.scrollTop > 20){
            this.classList.add("active");
        }
        else{
            if(this.classList.contains('active')){
                this.classList.remove("active");
            }
        }
    }

    syncStickyAddToCartPosition(){
        if(this.stickyAddToCart?.classList.contains("active")){
            this.classList.add("above-sticky-add-to-cart");
        }
        else{
            this.classList.remove("above-sticky-add-to-cart");
        }
    }

    disconnectedCallback(){
        this.stickyAddToCartObserver?.disconnect();
    }
}

customElements.get("scroll-to-top") || customElements.define("scroll-to-top", ScrollToTop);
